import { render, staticRenderFns } from "./TopProfile.vue?vue&type=template&id=297be748&scoped=true&"
import script from "./TopProfile.vue?vue&type=script&lang=js&"
export * from "./TopProfile.vue?vue&type=script&lang=js&"
import style0 from "./TopProfile.vue?vue&type=style&index=0&id=297be748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297be748",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VMenu})
